import { render, staticRenderFns } from "./ProducerAditional.vue?vue&type=template&id=1042784e"
import script from "./ProducerAditional.vue?vue&type=script&lang=js"
export * from "./ProducerAditional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports